<template>
  <div class="global-footer">
    <slot></slot>

    <footer class="main-footer" data-cy="main-footer">
      <span style="margin-right: auto; text-decoration: none">{{
        main.releaseVersionInfo
      }}</span>
      <a href="https://www.oukosher.org/privacy-policy/" target="_blank"
        >Privacy Policy</a
      >
      <a
        href="#"
        rel="nofollow"
        onclick="Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')"
        >Cookie Policy</a
      >
    </footer>
  </div>
</template>

<script lang="ts">
import { useMainStore } from "@/stores/useMainStore";
import { defineComponent } from "vue";

export default defineComponent({
  mounted() {
    const recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://cmp.osano.com/AzyvxUSByGm4feKh/055dfe51-491e-4606-bc03-b2e8ea2c8f5e/osano.js"
    );
    document.head.appendChild(recaptchaScript);
  },
  setup() {
    const main = useMainStore();

    return {
      main,
    };
  },
}) as any;
</script>
<style scoped lang="scss">
.main-footer {
  padding: 10px 12px;
  background: #efefef;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;

  @include media-breakpoint-up(md) {
    padding: 10px 30px;
  }
}
footer.main-footer a,
footer.main-footer span {
  color: #999;
  text-decoration: underline;
  font-size: 12px;
  line-height: 30px;

  &:not(:last-child) {
    margin-right: 20px;
  }
}
footer.main-footer a:hover {
  color: #666;
}
</style>
<style>
.osano-cm-widget {
  display: none !important;
}
</style>
